import { ResourceDto, ResourcesApi } from '../../../api-client';
import { useQuery, UseQueryOptions, UseQueryResult } from 'react-query';
import { ErrorResponse } from '../../../common/types/errorRespose';
import { getApiConfiguration } from '../../../common';

const QUERY_KEY = 'businessUnits';

export const useGetBusinessUnits = (
  options?: Omit<
    UseQueryOptions<ResourceDto[], ErrorResponse>,
    "queryKey" | "queryFn"
    >,
): UseQueryResult<ResourceDto[]> => {
  const tenantId = localStorage.getItem('tenantId') as string;
  const resourcesApi = new ResourcesApi(getApiConfiguration());

  return useQuery(
    [QUERY_KEY],
    async () => resourcesApi.getResources(tenantId).then(({ data }) => data),
    options,
  );
};
